import React from 'react';
import { mainColor } from '../../constants';

const Splash = ({ loading }) => (
  <div className={`load${loading ? '' : ' loaded'}`}>
    <div className='load__icon-wrap'>
      <svg className='load__icon'>
        <path fill={mainColor.secondaryColor} d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
      </svg>
    </div>
    {/* <div className={`load${loading ? '' : ' loaded'}`}>
      <div className='load__icon-wrap'>
        <img alt='dishop logo' className='img' src={logo} style={{ width: '170px' }} />
        <center style={{ margin: 'auto' }} className='pt-4'>
          <CircularProgress
            size={32}
            thickness={6.0}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
              color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
            }}
          />
        </center>
      </div>
    </div> */}
  </div>
);

export default Splash;
